<script setup lang="ts">
import { type Maintenance } from '@panel/plugins/types';
import ExternalLink from 'gpcore-uikit/components/Component.ExternalLink.vue';

defineProps<{
  maintenance: Maintenance;
}>();

const convertDate = (date: string) => {
  const dateObj = new Date(date);
  return dateObj.toLocaleString('default', {
    hour12: false,
    timeStyle: 'short',
    dateStyle: 'short',
  });
};
</script>

<template>
  <div>
    <template v-if="maintenance != null">
      <h4 class="tw-mb-4">
        {{ maintenance.name }}
      </h4>
      <p class="tw-mb-4">
        We will be performing maintenance on
        <strong>{{ convertDate(maintenance.scheduled_for) }}</strong
        >.
        <br />
        Estimated end time is
        <strong>{{ convertDate(maintenance.scheduled_until) }}</strong
        >.
      </p>
      <ExternalLink
        :url="maintenance.shortlink"
        class="tw-text-black tw-underline hover:tw-text-black"
      >
        Click here for more information
      </ExternalLink>
    </template>
  </div>
</template>

<style scoped></style>
